export default __webpack_public_path__ + "static/css-entertainment-logo-daac1720da39aea9b68a1cce51166437.png";